import { Injectable } from '@angular/core';
import { TelemetryIsActiveResolver } from '@cv-invision/cv.component-library.ux';
@Injectable()
export class IntelligenceIsActiveResolver implements TelemetryIsActiveResolver {
	/**
	 * Method to check if the telemetry is active
	 * for now I will leave as true
	 */
	isActive(): boolean {
		return true;
	}
}
